type CardTitleType = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export default function CardTitle({
  children,
  className,
  ...props
}: CardTitleType) {
  return (
    <h1 className={`text-xl font-semibold text-gray-800 ${className}`} {...props}>
      {children}
    </h1>
  );
}

